import { NavLink, Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

const TABS: { to: string; label: string; moduleKey?: string }[] = [
  { to: "/horeca/kuhinja", label: "Ekran kuhinje" },
  { to: "/horeca/izvestaji", label: "Izveštaji" },
  { to: "/horeca/popis", label: "Popis zaliha" },
  { to: "/horeca/normativ", label: "Normativ", moduleKey: "normativ" },
  { to: "/horeca/lojalti", label: "Lojalti program", moduleKey: "loyalti" },
  { to: "/horeca/knjige", label: "Knjige (KEP, DPU)" },
  { to: "/horeca/podesavanja", label: "Podešavanje" },
];

/** Zajednički okvir za sve HoReCa stranice: jedna stavka u meniju, ostalo su tabovi. */
export function HorecaLayout() {
  const { data } = useQuery({
    queryKey: ["my-company-modules-web"],
    queryFn: () => api.getMyCompanyModulesForWeb(),
    staleTime: 5 * 60_000,
  });
  const active = new Set(data?.modules.map((m) => m.key) ?? []);
  const tabs = TABS.filter((t) => !t.moduleKey || active.has(t.moduleKey));
  return (
    <div className="space-y-4">
      <nav className="flex flex-wrap gap-1 border-b border-border print:hidden" aria-label="HoReCa">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) =>
              `-mb-px border-b-2 px-3 py-2 text-sm font-medium ${isActive ? "border-brand text-brand" : "border-transparent text-slate-500 hover:text-slate-800"}`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
